import React, { useState } from 'react';
import './InputSearch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function InputSearch() {
    const [searchTerm, setSearchTerm] = useState('');
    const [modalOpen, setModalOpen] = useState(false);

    const enlaces = [
        { title: 'Productos', link: '/dashboard/productos' },
        { title: 'Banners', link: '/dashboard/banners' },
        { title: 'Usuarios', link: '/dashboard/usuarios' },
        { title: 'Contacto', link: '/dashboard/contacto' },
        { title: 'Categorias', link: '/dashboard/categorias' },
        { title: 'Codigos', link: '/dashboard/codigos' },
    ];

    const handleSearch = (event) => {
        const currentTerm = event.target.value;
        setSearchTerm(currentTerm);
        setModalOpen(currentTerm.trim() !== '');
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const filteredEnlaces = enlaces.filter((enlace) =>
        enlace.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="inputSearchDashboard">
            <div className='searchDashboardBox'>
                <FontAwesomeIcon icon={faSearch} className='searchDashboardBox__icon' />

                <input
                    type='text'
                    placeholder='Buscar módulo del dashboard...'
                    value={searchTerm}
                    onChange={handleSearch}
                    className='searchDashboardBox__input'
                />
            </div>

            {modalOpen && (
                <div className='searchDashboardModal'>
                    {filteredEnlaces.length > 0 ? (
                        filteredEnlaces.map((enlace, index) => (
                            <div key={index}>

                                <Link to={enlace.link} onClick={closeModal} className='searchDashboardModal__link'>
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    {enlace.title}
                                </Link>
                            </div>
                        ))
                    ) : (
                        <p className='searchDashboardModal__empty'>No hay resultados.</p>
                    )}
                </div>
            )}
        </div>
    );
}
